import { menuSpecialCardFactory } from './chunk-XGMI2YD6.mjs';
import { __spreadValues } from './chunk-T36PI2YV.mjs';
import pickBy from 'lodash/pickBy';

var menuItemSpecialsCardFactory = (specials, assignedSpecials) => {
  const specialIds = Object.values(assignedSpecials || {}).map(
    (special) => special.specialId
  );
  const specialsToRender = pickBy(
    specials,
    (special) => specialIds.includes(special.specialId)
  );
  return menuSpecialCardFactory(specialsToRender).map((special) => __spreadValues(__spreadValues({}, assignedSpecials[special.id]), special));
};

export { menuItemSpecialsCardFactory };
